import { coreActions } from '@sonar-software/sonar-core';
import { fieldSortOptions } from './FieldSortOptions';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { SelectionTable } from '@ui/tables';
import { getRowKey, paginationDefaultQueryParams, paginationFallbackQueryParams, PeriscopePagination } from '../';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { PeriscopeFieldRow, PeriscopeFieldSearch } from './';
import React, { useCallback, useEffect, useRef } from 'react';
import { useAction, useQueryResource, useSelectionTable } from '@hooks';
export const SalesforceFieldSearchableSelectionTable = ({ parentIndex, resourceIdsUri, showParents, sonarObjectId, uri }) => {
    const scrollableListRef = useRef(null);
    const updateReferences = useAction(coreActions.updateSonarObjectReferences);
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams: Object.assign(Object.assign({}, paginationDefaultQueryParams), { sortBy: fieldSortOptions[1].key, sortDirection: fieldSortOptions[1].direction }),
        fallbackParams: paginationFallbackQueryParams,
        uri
    });
    useEffect(() => {
        if (resource === null || resource === void 0 ? void 0 : resource.results) {
            updateReferences(resource.results.map((result) => ({
                displayName: result.displayName,
                ingestedBy: result.ingestedBy,
                parentDisplayName: result.parentDisplayName,
                parentSonarObjectId: result.parentSonarObjectId,
                populatedBy: result.populatedBy,
                relatedCounts: result.relatedCounts,
                sonarObjectId: result.sonarObjectId,
                sonarObjectType: SonarObjectType.SalesforceField,
                tags: result.tagIds
            })));
        }
    }, [resource === null || resource === void 0 ? void 0 : resource.results, updateReferences]);
    const selectionData = useSelectionTable({
        getRowKey,
        queryParams,
        resourceIdsUri,
        results: resource === null || resource === void 0 ? void 0 : resource.results,
        selectionType: SonarObjectType.SalesforceField
    });
    const renderField = useCallback((field) => React.createElement(PeriscopeFieldRow, { field: field, key: field.sonarObjectId, parentIndex: parentIndex, showParents: showParents, useApiNames: Boolean(queryParams.useInternal) }), [parentIndex, queryParams.useInternal, showParents]);
    const totalCount = resource === null || resource === void 0 ? void 0 : resource.totalCount;
    const results = resource === null || resource === void 0 ? void 0 : resource.results;
    return (React.createElement(React.Fragment, null,
        React.createElement(PeriscopeFieldSearch, { onChange: updateParams, queryParams: queryParams, sonarObjectId: sonarObjectId }),
        React.createElement(SelectionTable, { dataSource: results, forceShowSelection: resourceIdsUri ? undefined : false, loading: loading, ref: scrollableListRef, renderRow: renderField, rowKey: getRowKey, selectionData: selectionData, selectionType: PERISCOPE_TAB_TYPES.FIELDS }),
        React.createElement(PeriscopePagination, { loading: loading, onChange: updateParams, queryParams: queryParams, scrollRef: scrollableListRef, totalCount: Number(totalCount) })));
};
